import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TagsService } from 'src/app/services/tags.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent  {

  constructor(private router: Router, private videosService: VideosService, private tagsService: TagsService) { }



  // בעמודים שבהם יש חיפוש מפורט, לא תוצג חלונית חיפוש בראש הדף
  @Input()
  showSearch: boolean = true

  @Input()
  showCheckbox: boolean 

  // היסטוריה או מועדפים או אף אחד מהם
  @Input()
  selctedButton = ''

  @Input()
  loadingVideos:boolean

  @Output() showBlockedChanged = new EventEmitter();


  //כשמשתמש מכניס קלט, מבצע חיפוש
  makeSearch(text: string) {
    this.router.navigate([`search`], { queryParams: { 'selector': 'description', 'text': text, 'showBlocked': localStorage.getItem('showBlocked') } })
    if (text !== "") {
      const userId = JSON.parse(localStorage.getItem('user')).userId
      const showBlocked = localStorage.getItem('showBlocked') === 'true'
      this.router.navigate([`search`], { queryParams: { 'selector': 'description', 'text': text, 'showBlocked': showBlocked } })

    }
  }

  showBlockedChangedEvent() {
    this.showBlockedChanged.emit()
  }

}